// components/video.js

export default function initVideo() {
    const blocks = document.querySelectorAll('.video-block');

    blocks.forEach(block => {
        const video = block.querySelector('video');
        const pauseControls = block.querySelector('.pause-controls');
        const btn = pauseControls?.querySelector('.btn');
        const text = btn?.querySelector('.text');

        if (!video || !btn) return;

        btn.addEventListener('click', () => {
            if (video.paused) {
                video.play();
                pauseControls.classList.remove('is-paused');
                if (text) text.textContent = 'PAUSE';
            } else {
                video.pause();
                pauseControls.classList.add('is-paused');
                if (text) text.textContent = 'PLAY';
            }
        });
    });
}
